import React from 'react';
import { useAccess } from '../../access/context/AccessProvider';
import { Alert, Button, Image, Popover, theme } from 'antd';
import { API_DOMAIN } from '../../../components/constants';
import { PhotoTagPicker } from '../../query-photos/views/PhotoTagPicker';
import { photoLabel } from '../../query-photos/models/photoTags';

export function EnquiryPhotoRetag({ vm, image, className }) {
  const { can } = useAccess();
  if (!vm.photoTags || !can('sales_pipeline.manage_parts')) return null;
  return <Popover trigger="click" placement="bottom" content={<PhotoTagPicker photo={vm.photoTags.photo(image)} parts={vm.data.plan.parts} disabled={vm.photoTags.busy || !vm.photoTags.data} onChange={ids => vm.retag(image, ids)} />}>
    <Button className={className} size="small" type="text" aria-label={`Shows for photo ${image}`}>Shows: {photoLabel(vm.photoTags.photo(image), vm.data.plan.parts)} ▾</Button>
  </Popover>;
}
export function EnquiryPhotoStrip({ vm, partId = null }) {
  const { token } = theme.useToken();
  const photos = (vm.data.task.images || []).filter(image => {
    const photo = vm.photoTags?.photo(image) || vm.data.plan.photos?.find(item => item.image_id === image);
    return partId == null ? !photo || photo.general || photo.part_removed : !photo?.part_removed && photo?.query_part_ids?.includes(partId);
  });
  return <div aria-label={partId == null ? 'General photos' : `Part ${partId} photos`} role="region" style={{ marginBottom: 8 }}>
    {partId == null && <div style={{ color: token.colorTextSecondary, fontSize: 12 }}>General photos {photos.length ? '' : '— none'}</div>}
    {partId == null && vm.photoTags?.notice && <Alert type="warning" message={vm.photoTags.notice} />}
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>{photos.map(image => <div key={image} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Image alt="Query photo" src={/^https?:/.test(image) ? image : API_DOMAIN + image} width={56} height={56} style={{ objectFit: 'cover', borderRadius: 4 }} />
      <EnquiryPhotoRetag vm={vm} image={image} />
    </div>)}</div>
  </div>;
}
